import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';

import { convertFaIconToKebabCase } from '@cloud-wave/neon-common-lib/app';

import * as moduleIcons from 'lib/common/icons/moduleIcons';

export const getModuleIcon = ({
  icon,
  defaultIcon,
}: {
  icon?: string;
  defaultIcon: IconDefinition;
}): IconDefinition => {
  const iconDefinitions = Object.values(moduleIcons);

  if (!icon) {
    return defaultIcon;
  }

  const iconName = convertFaIconToKebabCase(icon);

  const iconDefinition = iconDefinitions.find((item) => item.iconName === iconName);

  return iconDefinition ? iconDefinition : defaultIcon;
};
